<script lang="babel">
import DocumentItem from '@/components/DocumentItem'
export default{
  components: {
    DocumentItem
  },
  data () {
    return {
      headers: [
        {
          text: 'Documento',
          value: 'documento',
          align: 'left'
        },
        {
          text: 'Fecha emisión',
          value: 'fecha_emision',
          align: 'left'
        },
        {
          text: 'Nombre o razón social',
          value: 'razon_social',
          align: 'left'
        },
        {
          text: 'Valor Venta',
          value: 'valor_venta',
          align: 'right'
        },
        {
          text: 'Monto exonerado',
          value: 'monto_exonerado',
          align: 'right'
        },
        {
          text: 'Monto IGV',
          value: 'monto_igv',
          align: 'right'
        },
        {
          text: 'Monto total',
          value: 'monto_total',
          align: 'right'
        }
      ]
    }
  }
}
</script>
<template lang="pug">
v-container(fluid)
  v-toolbar(
    flat
    color="white"
    )
    v-toolbar-title Listado de Documentos
    v-divider(
      vertical
      inset
      class="mx-4"
    )
    v-spacer
    document-item
  v-data-table(
    :headers="headers"
    no-data-text="Datos no disponibles"
    rows-per-page-text="Filas por página"
  )
</template>
<style lang="stylus">

</style>
